import React from 'react';
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import FormComponent from "../../form"
import { LongDownArrow } from "../../icons"

const Contact = ({title, form, image}) => {
  return (
    <section className="contact">
      <div className='contact__inner'>
        <div className='contact__form' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          {title && <h2>{parse(title)}</h2>}
          <FormComponent form={form[0].form} />
        </div>

        <div className='contact__image' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          {image && <Asset asset={image} />}
        </div>
        <Link className='contact__promt' to='#locations'><LongDownArrow/>our venues</Link>
      </div>
    </section>
  )
}

export default Contact

export const query = graphql`
fragment ContactProps on DatoCmsContact {
  ... on DatoCmsContact {
    id
    title
    image {
      ...InternalAssetProps
    }
    form {
      form {
        ...FormProps
      }
    }
  }
}
`